import styled from 'styled-components'
import { MAIN_COLORS } from '../../../../UI/consts/colors'
import { useEffect, useRef, useState } from 'react'
import { API } from '../../../../components/API'
import Skeleton from '../../../../UI/components/UIKit/Skeleton'
import { IStorie } from '../../../../components/types/stories'

const Wrapper = styled.div<{active: boolean}>`
    border-radius: 12px;
    padding: 2px;
    background: ${props => props.active ? MAIN_COLORS.gradient_yellow_pink : 'transparent'};
    width: 25vw;
    min-width: 25vw;
    height: 25vw;
    overflow: hidden;
    position: relative;
`
const Content = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background: #4A0066;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: flex-end;
`

const Image = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
    filter: brightness(0.75);
`
const Title = styled.h5`
    position: relative;
    z-index: 2;
    color: white;
    margin: 0;
    padding: 8px;
    text-align: left;
    width: 100%;
    background: linear-gradient(rgba(0, 0, 0, 0.7) 0%, transparent 100%);
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
    position: absolute;
    top: 0;
    left: 0;
`
const StorieItem = ({data, onOpen}:{data: IStorie, onOpen: (story: IStorie) => void}) => {
    const [ image, setImage ] = useState<string>('');
    const [ imgIsLoading, setImgIsLoading ] = useState(true);
    const cardRef = useRef<HTMLDivElement | null>(null);

    const getImage = async () => {
        const res = await API.getImageData(data.id,'stories');
        setImage(res);
    }

    useEffect( () => {
        getImage().finally(() => setImgIsLoading(false));
    }, [])

    const handleClick = () => {
        if (data.has_content) {
            onOpen(data);
        } else if (data.external_url) {
            window.Telegram.WebApp.openLink(data.external_url, {try_instant_view:true});
        }
    };

    return (
        <Wrapper onClick={handleClick} ref={cardRef} active={true}>
            <Content>
                {imgIsLoading ? (
                    <Skeleton height={'25vw'} width={'25vw'} radius={'12px'}/>
                ) : (
                    <>
                        <Image
                            src={image}
                            alt={data.title}
                        />
                        <Title>{data.title}</Title>
                    </>
                )}
            </Content>
        </Wrapper>
    )
}

export default StorieItem
